import { createContext, useContext, type ReactNode } from 'react';
import type { appServices } from '@/services/app';

type AppServices = typeof appServices;

const AppServicesContext = createContext<AppServices | null>(null);

export function useServices() {
  const services = useContext(AppServicesContext);
  if (!services) {
    throw new Error('useServices must be used within AppServicesProvider');
  }
  return services;
}

interface AppServicesProviderProps {
  children: ReactNode;
  services: AppServices;
}

export function AppServicesProvider({
  children,
  services,
}: AppServicesProviderProps) {
  return (
    <AppServicesContext.Provider value={services}>
      {children}
    </AppServicesContext.Provider>
  );
}
